import { myOrdersSlice } from './slice'

// Get All
export const { setMyOrdersLoading } = myOrdersSlice.actions
export const { setMyOrdersResponse } = myOrdersSlice.actions
export const { setMyOrdersError } = myOrdersSlice.actions
export const { setSelectedOrders } = myOrdersSlice.actions
export const { setFilteredOrders } = myOrdersSlice.actions
export const { setFilterOrderText } = myOrdersSlice.actions
export const { resetMyOrdersState } = myOrdersSlice.actions

// Get Certificates Reducers
export const { setOrderCertificatesLoading } = myOrdersSlice.actions
export const { setOrderCertificatesSuccess } = myOrdersSlice.actions
export const { setOrderCertificatesData } = myOrdersSlice.actions
export const { resetOrderCertificatesState } = myOrdersSlice.actions

// Get One Order Reducers
export const { setGetOneOrderLoading } = myOrdersSlice.actions
export const { setGetOneOrderError } = myOrdersSlice.actions
export const { setGetOneOrderData } = myOrdersSlice.actions
export const { resetGetOneOrderState } = myOrdersSlice.actions

// Get One Order and All Order Items Reducers
export const { setGetAllOrderItemsLoading } = myOrdersSlice.actions
export const { setGetAllOrderItemsError } = myOrdersSlice.actions
export const { setGetAllOrderItemsData } = myOrdersSlice.actions
export const { resetGetAllOrderItemsState } = myOrdersSlice.actions
